import { useState } from "react";

const BACKUP_ALERT_STORAGE_KEY = "senseguard:backup-alert-dismissed";

export function getBackupAlertDismissed(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(BACKUP_ALERT_STORAGE_KEY) === "true";
}

export function setBackupAlertDismissed(value: boolean): void {
  if (typeof window === "undefined") return;
  if (value) {
    window.localStorage.setItem(BACKUP_ALERT_STORAGE_KEY, "true");
  } else {
    window.localStorage.removeItem(BACKUP_ALERT_STORAGE_KEY);
  }
}

export function useBackupAlertPreference() {
  const [dismissed, setDismissedState] = useState<boolean>(() => getBackupAlertDismissed());

  const setDismissed = (value: boolean) => {
    setBackupAlertDismissed(value);
    setDismissedState(value);
  };

  return { dismissed, setDismissed };
}
